import { render, staticRenderFns } from "./HighEndPreferredProduct.vue?vue&type=template&id=340ed360&scoped=true&"
import script from "./HighEndPreferredProduct.vue?vue&type=script&lang=js&"
export * from "./HighEndPreferredProduct.vue?vue&type=script&lang=js&"
import style0 from "./HighEndPreferredProduct.vue?vue&type=style&index=0&id=340ed360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ed360",
  null
  
)

export default component.exports